import { Model } from './model';
import { FilterHandler } from '../shared/filter-handler';

import { DebarkationItem } from './debarkation-item';
import { Ship } from './ship';

import * as moment from 'moment';

export class ControlItem extends Model {
  id: number;
  capture_weight: number;
  capture_exemplars_number: number;
  discard_weight: number;
  initial_weight: number;
  final_weight: number;
  debarkation_weight: number;
  debarkation_exemplars_number: number;
  live_weight: number;
  status: string;
  error_description: string;
  fao_zone: string;
  specie: string;
  ship: string;
  tide: string;
  tide_start_date: moment.Moment;
  debarkation_items: DebarkationItem[];

  debarkation_items_count: number;
  presentation_type_name: string;
  presentation_type_conversion_factor: number;
  conversion_factor_error: boolean;
  right_conversion_factor: number;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const control_item = new ControlItem(values);

    control_item.debarkation_items = [];
    if (control_item.tide) {
      control_item.tide_start_date = control_item.tide['start_date'];
    }

    if (values['debarkation_items']) {
      for (const item of values['debarkation_items']) {
        const debarkation_item = new DebarkationItem(item);
        control_item.debarkation_items.push(debarkation_item);
      }

      control_item.debarkation_items_count = control_item.debarkation_items.length;

      if (control_item.debarkation_items_count === 1) {
        control_item.presentation_type_name = control_item.debarkation_items[0].presentation_type_name;
        control_item.presentation_type_conversion_factor = control_item.debarkation_items[0].presentation_type_conversion_factor;
        control_item.conversion_factor_error = control_item.debarkation_items[0].conversion_factor_error;
        control_item.right_conversion_factor = control_item.debarkation_items[0].right_conversion_factor;
      }
    }

    return control_item;
  }
}

export class IncidenceFilter extends FilterHandler {
  code: string;
  ship: Ship[] = [];
  start_date: string;
  end_date: string;
  show_ignored: boolean;

  constructor(values: Object = {}) {
    super();

    this.code = '';
    this.ship = [];
    this.start_date = '';
    this.end_date = '';

    this.unSerializedRouterParams(values);
  }

  serializeQueryParams(params) {
    let string_params = super.serializeQueryParams(params);

    if (params['show_ignored'] === 'true') {
      string_params += 'status=ignored&';
    }

    return string_params;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/control-item.ts